<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-hover v-slot="{ hover }">
          <v-btn
            block
            height="80"
            class="success mr-1"
            :elevation="hover ? 8 : 2"
            v-on="{ ...tooltip }"
            :disabled="newPendDisabled"
            @click="assignBranch()"
          >
            <div class="d-flex flex-column align-center">
              <v-icon>mdi-file-cabinet</v-icon>
              <span class="action-text">ASSIGN BRANCH</span>
            </div>
          </v-btn>
        </v-hover>
      </template>
      <span>ASSIGN BRANCH</span>
    </v-tooltip>

    <!-- THE DIALOG BEGINS HERE -->

    <v-dialog v-model="dialogAssignBranch" max-width="750px">
      <template v-if="editedCasefile">
        <v-card>
          <v-card-title>
            <span class="text-h5">ASSIGN BRANCH</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-card width="100%">
                  <v-card-title>Department</v-card-title>
                  <v-col cols="12">
                    <v-select
                      v-model="editedCasefile.refType"
                      :items="sortedRefType"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ maxHeight: '400' }"
                      hint="Select Department"
                      persistent-hint
                      label="Department"
                      @change="handleRefTypeChange"
                    >
                      <template #label>
                        <span class="red--text"><strong>* </strong></span
                        >Department
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="editedCasefile.subRefType"
                      :items="sortedAvailableSubRefTypes"
                      item-text="subCode"
                      item-value="id"
                      no-data-text="There is no file-Classification option for selected department above"
                      :menu-props="{ maxHeight: '400' }"
                      label="File-Classification"
                      hint="Select File-Classification"
                      persistent-hint
                    ></v-select>
                  </v-col>
                </v-card>

                <v-col cols="12">
                  <v-select
                    v-model="editedCasefile.branch"
                    :items="sortedBranches"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400' }"
                    hint="Set the casefile branch"
                    persistent-hint
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>Branch
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedCasefile.insurer"
                    :items="sortedInsurer"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400' }"
                    hint="Set the casefile insurer"
                    persistent-hint
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>Insurer
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="editedCasefile.handler"
                    :items="sortedHandlers"
                    item-text="name"
                    item-value="id"
                    no-data-text="There is no handler option for selected insurer above"
                    :menu-props="{ maxHeight: '400' }"
                    label="Claim Handler"
                    hint="Select Handler"
                    persistent-hint
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedCasefile.claimNo"
                    item-text="Insurer's Reference"
                    :rules="[(v) => !!v || 'Insurers reference is required']"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>Insurers
                      Reference
                    </template></v-text-field
                  >
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <template>
                    <div>
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        max-width="290"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedCasefile.dateOfAssign"
                            :value="computedDateFormattedMomentjs"
                            clearable
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @click:clear="date = null"
                          >
                            <template #label>
                              <span class="red--text"><strong>* </strong></span
                              >Date Of Assignment
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedCasefile.dateOfAssign"
                          :value="computedDateFormattedMomentjs"
                          @change="menu = false"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                  </template>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedCasefile.vehicleNo"
                    :rules="[(v) => !!v || 'Vehicle Number is required']"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>Vehicle
                      Number
                    </template></v-text-field
                  >
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <template>
                    <div>
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        max-width="290"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedCasefile.dateOfLoss"
                            :value="computedDateFormattedMomentjs"
                            clearable
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @click:clear="date = null"
                          >
                            <template #label>
                              <span class="red--text"><strong>* </strong></span
                              >Date Of Loss
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedCasefile.dateOfLoss"
                          :value="computedDateFormattedMomentjs"
                          @change="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                  </template>
                </v-col>

                <v-card width="100%">
                  <v-card-title>Place Of Loss</v-card-title>
                  <v-col cols="12">
                    <v-select
                      v-model="editedCasefile.stateOfLoss"
                      :items="sortedStates"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ maxHeight: '400' }"
                      hint="Select State"
                      persistent-hint
                      label="State"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="editedCasefile.placeOfLoss"
                      :items="sortedRegions"
                      item-text="name"
                      item-value="name"
                      no-data-text="There is no district option for selected state above"
                      :menu-props="{ maxHeight: '400' }"
                      label="Area Of Loss"
                      hint="Select District"
                      persistent-hint
                    ></v-select>
                  </v-col>
                </v-card>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedCasefile.insuredName"
                    label="Insured Name"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="editedCasefile.insComment"
                    label="Insurers Comment"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>Insurers
                      Comment
                    </template>
                  </v-textarea>
                </v-col>

                <v-col cols="12">
                  <v-spacer></v-spacer>
                  <v-btn
                    tile
                    dark
                    small
                    @click="closeAssignBranchDialog"
                    class="mt-3 mr-2 error"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    tile
                    small
                    :disabled="isAddFileButtonDisabled"
                    class="mt-3 success"
                    @click="assignBranchSubmit"
                    >Submit</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";
import MailDataService from "../../services/MailDataService";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "AssignBranch",
  props: [
    "branches",
    "branch",
    "management",
    "insurer",
    "refType",
    "subRefTypes",
    "members",
    "handlers",
    "states",
    "regions",
  ],
  components: {},

  data() {
    return {
      dialogAssignBranch: false,
      menu: false,
      menu1: false,
      editedCasefile: null, // Local copy for editing
    };
  },

  computed: {
    ...mapState(["caseState"]),

    // Sort departments alphabetically and uppercase
    sortedRefType() {
      const list = this.refType || [];
      return list
        .map((d) => ({
          ...d,
          name: d.name ? d.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    // File Classification dependent on selected Department, sorted and uppercase
    sortedAvailableSubRefTypes() {
      if (!this.editedCasefile || !this.editedCasefile.refType) return [];
      const list = this.subRefTypes || [];
      return list
        .filter((sub) => sub.deptId === this.editedCasefile.refType)
        .map((sub) => ({
          ...sub,
          subCode: sub.subCode ? sub.subCode.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.subCode.localeCompare(b.subCode));
    },
    // Sort branches alphabetically and uppercase
    sortedBranches() {
      const list = this.branches || [];
      return list
        .map((b) => ({
          ...b,
          name: b.name ? b.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    // Sort insurers alphabetically and uppercase
    sortedInsurer() {
      const list = this.insurer || [];
      return list
        .map((i) => ({
          ...i,
          name: i.name ? i.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    // Sort handlers alphabetically and uppercase, filtered by insurer
    sortedHandlers() {
      if (!this.editedCasefile || !this.editedCasefile.insurer) return [];
      const list = this.handlers || [];
      return list
        .filter((h) => h.insId === this.editedCasefile.insurer)
        .map((h) => ({
          ...h,
          name: h.name ? h.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },

    isAddFileButtonDisabled() {
      return !(
        this.editedCasefile.refType &&
        this.editedCasefile.branch &&
        this.editedCasefile.insurer &&
        this.editedCasefile.claimNo &&
        this.editedCasefile.vehicleNo &&
        this.editedCasefile.dateOfLoss &&
        this.editedCasefile.insComment
      );
    },

    computedDateFormattedMomentjs() {
      return this.date ? moment(this.date).format("DD/MM/YY") : "";
    },

    newPendDisabled() {
      return !(
        (this.caseState.casefile.fileStatus == `NEW` ||
          this.caseState.casefile.fileStatus == `PEND`) &&
        this.management
      );
    },

    availableSubRefTypes() {
      // Deprecated: use sortedAvailableSubRefTypes instead
      return [];
    },
    sortedStates() {
      const list = this.states || [];
      return list
        .map((s) => ({
          ...s,
          name: s.name ? s.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedRegions() {
      if (!this.editedCasefile || !this.editedCasefile.stateOfLoss) return [];
      const list = this.regions || [];
      return list
        .filter((region) => region.branchId === this.editedCasefile.stateOfLoss)
        .map((region) => ({
          ...region,
          name: region.name ? region.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
  },

  watch: {
    assignBranch(val) {
      val || this.closeAssignBranchDialog();
    },
  },

  methods: {
    // moment: function (date) {
    //   return moment(date);
    // },
    filterHandler(item) {
      const list = this.handlers || [];
      return list.filter((handler) => handler.insId === item);
    },
    filterBranchName(item) {
      if (!item) return "TBA";
      const list = this.branches || [];
      const filteredbranch = list.filter((branch) => branch.id === item);
      return filteredbranch[0] ? filteredbranch[0].name : "";
    },
    filterBranches(item) {
      const list = this.branches || [];
      return list.filter((branch) => branch.id === item);
    },

    filterRegions(item) {
      const list = this.regions || [];
      return list.filter((region) => region.branchId === item);
    },
    filterPicID(item) {
      if (!item) return "TBA";
      const filteredDept = this.refType.filter((dept) => dept.id === item);
      return filteredDept[0].picID;
    },

    filterDept(item) {
      const list = this.refType || [];
      return list.filter((dept) => dept.id === item);
    },
    filterSubDept(item) {
      const list = this.subRefTypes || [];
      return list.filter((subRef) => subRef.id === item);
    },
    filterIns(item) {
      const list = this.insurer || [];
      return list.filter((insurer) => insurer.id === item);
    },

    findUserEmail(item) {
      const user = this.members.filter((member) => member.id === item);
      return user[0] ? user[0].email : "sys.admin@associatedadjusters.com";
      // return user.map((b) => b.email);
    },

    filterVehiclNo(item) {
      if (!item) return "TBA";
      return item.toLowerCase().replace(/\s/g, "");
    },
    assignBranch() {
      // Clone casefile for local editing
      this.editedCasefile = JSON.parse(JSON.stringify(this.caseState.casefile));
      this.dialogAssignBranch = true;
    },

    assignBranchSubmit() {
      // Use editedCasefile for submission
      const payload = {
        ...this.editedCasefile,
        vehicleNo: this.editedCasefile.vehicleNo
          ? this.editedCasefile.vehicleNo.toLowerCase().replace(/\s/g, "")
          : "",
        fileStatus: "BRAC",
        assignBranchBy: this.$store.state.auth.user.id,
        dateOfReg: moment().format(),
      };
      CasefileDataService.update(this.caseState.casefile.id, payload)
        .then((response) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "warning",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });
          // Update global casefile only after success
          this.caseState.casefile = payload; // <-- Replace mutation with direct assignment
          this.closeAssignBranchDialog();
        })
        .catch((e) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text:
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              toString(),
          });
        })

        .then(() => {
          // const assignedBranch = this.caseState.casefile.branch;
          const assignedDept = this.caseState.casefile.refType;
          var dataEmail = {
            id: this.caseState.casefile.id,
            refType: this.filterDept(this.caseState.casefile.refType)[0]
              .description,
            refTypeCode: this.filterDept(this.caseState.casefile.refType)[0]
              .name,
            subRefType: this.filterSubDept(
              this.caseState.casefile.subRefType
            )[0].subCodeDesc,
            subRefCode: this.filterSubDept(
              this.caseState.casefile.subRefType
            )[0].subCode,
            branch: this.filterBranchName(this.caseState.casefile.branch),
            branchCode: this.filterBranches(this.caseState.casefile.branch)[0]
              .brCode,
            insurer: this.filterIns(this.caseState.casefile.insurer)[0].name,
            vehicleNo: this.caseState.casefile.vehicleNo
              .toLowerCase()
              .replace(/\s/g, ""),
            // vehicleNo: this.caseState.casefile.vehicleNo,
            recipient: this.findUserEmail(this.filterPicID(assignedDept)),
            createdBy: this.$store.state.auth.user.id,
          };

          MailDataService.assignBranch(dataEmail)
            .then((response) => {
              this.closeAssignBranchDialog();
              this.$store.dispatch("setSnackbar", {
                showing: true,
                color: "warning",
                text:
                  (response && response.data && response.data.message) ||
                  toString(),
              });
              // this.refreshList();
            })
            .catch((e) => {
              console.log(e);
            });
          this.dataEmail = "";
        })
        .catch((e) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text:
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              toString(),
          });
        });
      this.closeAssignBranchDialog();
    },

    closeAssignBranchDialog() {
      this.dialogAssignBranch = false;
      this.$nextTick(() => {
        // this.caseState.casefile = Object.assign({});
        // this.caseState.casefile.fileStatus = "INC";
      });
    },

    handleRefTypeChange() {
      // Reset subRefType when Department changes
      if (this.editedCasefile) {
        this.editedCasefile.subRefType = null;
      }
    },
  },
};
</script>
